import { Validator } from "fluentvalidation-ts";
import { matchIsValidTel } from "mui-tel-input";

type Company = {

  name:string;
  phoneNumber: string;
  cellNumber:string;
  address:string;
  email: string;
  taxNumber: string;
  vatNumber:string;
};

class CompanyValidator extends Validator<Company> {
  constructor() {
    super();

    this.ruleFor("name")
      .notNull()
     .withMessage("Campo obbligatorio");


    this.ruleFor("address") // This is type-safe! (Argument is of type 'name' | 'age')
      .notEmpty()
      .notNull()
      .withMessage("Required field");



      this.ruleFor("taxNumber") // This is type-safe! (Argument is of type 'name' | 'age')
      .notEmpty()
      .notNull()
      .withMessage("Required field");



     this.ruleFor("cellNumber") // This is type-safe! (Argument is of type 'name' | 'age')
       .notEmpty()
       .notNull()
     .withMessage("Please insert a valid cellphone number ")
     .must((phone) => matchIsValidTel(phone))
     .withMessage("Number not valid");

   this.ruleFor("email")
     .notEmpty()
     .notNull()
     .withMessage("Please enter your email")
     .emailAddress()
     .withMessage("E-mail not valid");

   this.ruleFor("phoneNumber")
     .notEmpty()
     .notNull()
     .withMessage("Please insert a valid phone number")
     .must((phone) => matchIsValidTel(phone))
     .withMessage("Numero non valido");


     this.ruleFor("vatNumber")
     .notEmpty()
     .notNull()
     .withMessage("Required field"); 

  }
  
}

export default CompanyValidator;
